<template lang="pug">
transition(name="modal")
  .modal-mask
    .modal-wrapper.modal
      .modal-dialog(role="document")
        .modal-content
          .modal-header
            h1 Thank you for your order
          .modal-body
            .text-center
              img(src="../assets/checkout_checkmark.png")
            h5.mt-3 Order number is: {{ referenceId }}
            p Your will receive an email confirmation shortly at {{ email }}. Thank you!
            p Please wait for you order to be accepted before sending payment, you will be notified via email.
          .modal-footer
            button.btn.btn-primary(@click="clickDoneButton") Done
</template>

<script>
export default {
  props: ['referenceId', 'email'],
  methods: {
    clickDoneButton () {
      this.$modal.close()
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/views/CheckoutSuccessModal.vue